import cn from 'classnames'
import Link, { LinkProps } from 'next/link'
import React from 'react'

export interface LightTabsProps {
	items: Array<{
		isActive: boolean
		isDisabled? : boolean
		label: React.ReactNode
		linkProps: LinkProps
	}>
	aside?: React.ReactNode
}

export const LightTabs: React.FunctionComponent<LightTabsProps> = ({
	items,
	aside,
}) => (
	<div className="lightTabs">
		<div className="lightTabs-in">
			{items.map((item, i) => (
				<Link {...item.linkProps} key={i}>
					<a className={cn('lightTabs-item', item.isActive && 'is-active', item.isDisabled && 'is-disabled')}>
						{item.label}
					</a>
				</Link>
			))}
			{aside && <div className="lightTabs-aside">{aside}</div>}
		</div>
	</div>
)
